import React from 'react';
import { io } from "socket.io-client";
import { SERVER_SOCKET } from "../config.json";

export const socket = io(SERVER_SOCKET,{
    withCredentials: true,
     transports: ["polling"]
});
export const SocketContext = React.createContext();
